import { render, staticRenderFns } from "./StockAlert.vue?vue&type=template&id=3c74504e&"
import script from "./StockAlert.vue?vue&type=script&lang=js&"
export * from "./StockAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports